import { render, staticRenderFns } from "./NotificationPanel.vue?vue&type=template&id=1e68b3b1&scoped=true&"
import script from "./NotificationPanel.vue?vue&type=script&lang=ts&"
export * from "./NotificationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPanel.vue?vue&type=style&index=0&id=1e68b3b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e68b3b1",
  null
  
)

export default component.exports